import { Control, Controller, MultipleFieldErrors } from 'react-hook-form'
import { IconButton, TextField, Tooltip } from '@mui/material'
import HelpIcon from '@mui/icons-material/Help'

interface FormTextFieldProps {
  control?: Control
  errors?: {
    type?: string
    message?: string
    types?: MultipleFieldErrors
  }
  name: string
  label: string
  multilineValue?: number
  length?: boolean
  type?: string
  subLabel?: string
  toolTipDescription?: string
  doNotRecord?: boolean
}

export const FormTextField = ({
  control,
  errors,
  name,
  label,
  multilineValue,
  length,
  type,
  subLabel,
  toolTipDescription,
  doNotRecord,
}: FormTextFieldProps) => {
  const isPasswordField = type === 'password'

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <div
          className={`w-full mb-25 min-w-300px 
            ${length ? 'w-full' : 'desktop-w-50'}`}
        >
          <div className="flex items-center justify-start">
            <p className="text-label">{label}</p>
            {toolTipDescription && (
              <Tooltip title={toolTipDescription}>
                <IconButton>
                  <HelpIcon />
                </IconButton>
              </Tooltip>
            )}
          </div>
          {subLabel && <p className="mt-0 fs-14 fw-600">{subLabel}</p>}

          <TextField
            {...(doNotRecord && { 'data-private': true })}
            variant="outlined"
            multiline={multilineValue ? true : false}
            autoComplete="off"
            rows={multilineValue || 1}
            placeholder={label}
            value={
              value === null || value === undefined || value === 'undefined'
                ? ''
                : value
            }
            sx={{
              width: '100%',
              background: '#fff',
              borderRadius: 2,
              '& .MuiOutlinedInput-root': {
                '& > fieldset': {
                  border: 'none',
                },
              },
            }}
            onChange={onChange}
            inputProps={{
              style: isPasswordField ? { fontFamily: 'monospace' } : {},
            }}
          />
          {errors?.message !== undefined && (
            <p className="error-text">{errors.message}</p>
          )}
        </div>
      )}
    />
  )
}
